module.exports = __webpack_public_path__ + "img/misc1.27b2bf8f.png";